import { createFileRoute } from "@tanstack/react-router";
import { DeptContentList } from "@/components/dept-content/DeptContentList";
import { PROGRAMMES } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/structure/programmes/")({
  component: () => <DeptContentList cfg={PROGRAMMES} />,
});
